export enum DoughnutChartHoleType {
  Percentage = 'percentage',
  Value = 'value'
}
